import { Building2, DoorOpen, Home, LayoutDashboard } from 'lucide-vue-next'
import type { SearchType } from '~/composables/stores/search'
import type { Component } from 'vue'

export interface SearchTypeMeta {
  label: string
  sectionLabel: string
  icon: Component
  color: string
  bg: string
}

export const useSearchTypeMeta = () => {
  const t = useTranslator()

  const typeMeta = computed<Record<SearchType, SearchTypeMeta>>(() => ({
    ASSET_MANAGEMENT_PORTFOLIO: { label: t('PORTFOLIO'), sectionLabel: t('PORTFOLIO'), icon: Home, color: '#7db8e8', bg: 'rgba(125,184,232,0.12)' },
    ASSET_MANAGEMENT_PROPERTY: { label: t('PROPERTY'), sectionLabel: t('PROPERTY'), icon: Building2, color: '#a6d793', bg: 'rgba(166,215,147,0.12)' },
    ASSET_MANAGEMENT_TENANCY: { label: t('TENANCY'), sectionLabel: t('TENANCY'), icon: DoorOpen, color: '#95a4a7', bg: 'rgba(149,164,167,0.12)' },
    CANVAS_LAYOUT: { label: t('SIDE_MENU_ITEM_REPORTS'), sectionLabel: t('SIDE_MENU_ITEM_REPORTS'), icon: LayoutDashboard, color: '#d8ad63', bg: 'rgba(216,173,99,0.15)' },
  }))

  const getMeta = (type: SearchType): SearchTypeMeta => typeMeta.value[type]
  return { typeMeta, getMeta }
}
